/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-performance-chart-host',
  template: `
    <adn-performance-chart
      [obj]="model"
      [adnChartType]="chartType"
      [absChunkMin]="absChunkMin"
      [groupBy]="groupBy"
      [groupById]="groupById">
    </adn-performance-chart>
  `
})
export class PerformanceChartHostComponent {
  @Input() model: any;
  @Input() chartType: string;
  @Input() absChunkMin = 'HOURLY';
  @Input() groupBy?: string;
  @Input() groupById?: string;
}
